import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

const Popup = ({ show, onClose,headerClass,children, headerText, headerIcon}) => { 

    return ( 
       <>
      <Modal
        className="modal send-confirm"
        id="delete-confirm"
        backdrop="static"
        keyboard={false}
        show={show}
        onHide={() => onClose()}
      >
        <Modal.Header>
             {headerIcon && <img src={path_image + headerIcon} alt="" />}
             {headerText || ""}
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            onClick={() => onClose()}
          ></button>
        </Modal.Header>
         <Modal.Body>
        {children}
         </Modal.Body>
        
      </Modal>
    </>
    );
};

export default Popup;